import React from 'react';
import { useCartStore } from '../store/cartStore';
import './StockAlert.css';

interface StockAlertProps {
    position?: 'fixed' | 'inline';
    className?: string;
}

export const StockAlert: React.FC<StockAlertProps> = ({
    position = 'fixed',
    className = ''
}) => {
    const { stockAlert, setStockAlert } = useCartStore();

    if (!stockAlert) return null;

    const handleDismiss = () => {
        setStockAlert(null);
    };

    return (
        <div className={`stock-alert ${position} ${className}`}>
            <div className="alert-header">
                <span className="alert-icon">⚠️</span>
                <span className="alert-title">Cart Updated</span>
                <button
                    className="alert-close"
                    onClick={handleDismiss}
                    aria-label="Dismiss alert"
                >
                    ×
                </button>
            </div>
            <div className="alert-content">
                {stockAlert.removedItems.length > 0 && (
                    <p className="alert-message">
                        <strong>Removed items:</strong> {stockAlert.removedItems.join(', ')} (out of stock)
                    </p>
                )}
                {stockAlert.adjustedItems.length > 0 && (
                    <div className="alert-adjustments">
                        <strong>Quantity adjusted:</strong>
                        {stockAlert.adjustedItems.map((item, index) => (
                            <p key={index} className="alert-message">
                                {item.productName}: {item.requestedQuantity} → {item.availableQuantity}
                            </p>
                        ))}
                    </div>
                )}
                {stockAlert.message && (
                    <p className="alert-message">{stockAlert.message}</p>
                )}
            </div>
        </div>
    );
};
